import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pageImages } from '../../data/siteData';
import PagePhotoViewer from '../../elements/PagePhotoViewer';

const images = pageImages['open-end-manual-tie-balers'];


const openEndManualModelHeaders = ['Series', '2424', '3030', '3430', '3442', '5030', '5042', '6042', '6046'];

const openEndManualModelRows = [
  ['Hopper/Feed Opening (LxW)', '24 X 24', '30 X 30', '34 X 30', '34 X 42', '50 X 30', '50 X 42', '60 X 42', '60 X 46'],
  ['Strokes Per Minute', '2 to 5', '2 to 5', '2 to 6', '2 to 6', '2 to 6', '2 to 6', '2 to 6', '2 to 6'],
  ['Cylinder Bore', '6, 7, 8 or 10', '6, 7, 8 or 10', '6, 7, 8 or 10', '6, 7, 8 or 10', '7, 8 or 10', '7, 8 or 10', '7, 8 or 10', '7, 8 or 10'],
  ['Power Unit HP', '20 to 60', '20 to 50', '30 to 50', '30 to 50', '30 to 50', '30 to 60', '30 to 60', '30 to 60'],
];

function OpenEndManualTieBalers() {
  return (
    <main className="detail-main">
      <section className="detail-layout">
        <aside>
          <span className="eyebrow">In This Section</span>
          <Link to="/closed-end-manual-tie-balers">Closed-End Manual Tie Balers</Link>
          <Link to="/open-end-automatic-tie-balers">Open-End Automatic Tie Balers</Link>
          <Link to="/wide-mouth-open-end-automatic-tie-balers">Wide-Mouth Open-End Automatic Tie Balers</Link>
          <Link to="/multi-materials-full-eject-closed-end-balers">Multi Materials Full-Eject Closed-End Balers</Link>
          <Link className="active" to="/open-end-manual-tie-balers">Open-End Manual Tie Balers</Link>
          <Link to="/cart-lifters-dumpers-dump-carts">Cart Lifters, Dumpers &amp; Dump Carts</Link>
          <Link to="/conveyors-bale-conveying-bagging-systems">Conveyors, Bale Conveying &amp; Bagging Systems</Link>
          <Link to="/used-clothing-balers">Used Clothing Balers</Link>
          <Link to="/cotton-gin-textile-baling-presses">Cotton Gin &amp; Textile Baling Presses</Link>
          <Link to="/biomass-cotton-gin-trash-baling-press">Biomass &amp; Cotton Gin Trash Baling Press</Link>
          <Link to="/vertical-down-packing-baling-presses-balers">Vertical &amp; Down-Packing Baling Presses &amp; Balers</Link>
          <Link to="/custom-designed-specialty-balers">Custom Designed &amp; Specialty Balers</Link>
          <Link to="/precrush-compactors-waste-compactors">PreCrush Compactors &amp; Waste Compactors</Link>
        </aside>
        <article className="article">
          <span className="eyebrow">Products</span>
          <h2>Open-End Manual Tie Balers</h2>
          <div className="body-copy page-summary-copy"><strong>Manual tie horizontal open-end balers</strong> provide lower-cost low and medium production baling for paper, corrugated, non-wovens, aluminum beverage containers, and other <strong>industrial trimmings</strong>.</div>
          
          <div className="page-summary-notes">
              <span>Open-end extrusion chamber resistance</span>
              <span>Lower-cost horizontal production</span>
              <span>Common manual tie option</span>
          </div>
          <PagePhotoViewer title="Open-End Manual Tie Balers" images={images} leadText={"Manual Tie Horizontal Open-End Balers for lower cost low and medium production baling of paper, paper trim, corrugated & box board trim, non-wovens, aluminum beverage containers, and other industrial trimmings & by-products. This style baler has the advantages of open-end production requiring only about 50% of the labor compared to a closed-end manual tie baler. Open-end manual tie bales are useful when baling multi-material such as a few bales of OCC, then a couple bales of plastic film or used beverage containers. Bale lengths are programmable or can be tied short with a one button depression, as is needed when baling multi-materials for bale separation when changing to another material."} eyebrow="Equipment Photos" />
          <div className="content-stack">
            
            <section className="content-block">
              <h3>Standard Single Ram Open-End Manual Tie Models</h3>
              <div className="body-copy">The original open-end manual tie model table gives the standard <strong>feed opening</strong>, stroke, cylinder bore, and <strong>horsepower ranges</strong> used when comparing C+M open-end manual tie balers.</div>
              <div className="spec-table-block">
                <table className="spec-table">
                  <thead>
                    <tr>{openEndManualModelHeaders.map((header) => <th key={header}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {openEndManualModelRows.map((row) => (
                      <tr key={row[0]}>{row.map((cell, cellIndex) => <td key={`${row[0]}-${cellIndex}`}>{cell}</td>)}</tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <Link className="button" to="/contact/request-quote">Request a Quote <ArrowRight size={16} /></Link>
        </article>
      </section>
    </main>
  );
}

export default OpenEndManualTieBalers;
